import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { LINEUPS } from '../../../../../packages/constants/widgetIds';

export const lineupsAttributes = getWidgetAttributes(
  LINEUPS,
  // Required attributes:
  [WidgetAttributes.WIDGET_ID, WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.MATCH],
  // Optional attributes:
  [
    WidgetAttributes.ELEMENTS,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.HEADER_DISPLAY,
    WidgetAttributes.HOME_TEAM_COLOR,
    WidgetAttributes.AWAY_TEAM_COLOR,
    WidgetAttributes.LABELS,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.THEME,
    WidgetAttributes.NAME_FORMAT,
  ],
);
